import { render, staticRenderFns } from "./AulasEmConflitos.vue?vue&type=template&id=c0511ccc"
import script from "./AulasEmConflitos.vue?vue&type=script&lang=js"
export * from "./AulasEmConflitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports